import PreloadIframe from '../../../../../pages/vip/features/prescription_required_disclaimer/index';

export default PreloadIframe;
